<template lang="pug">
.v-categories.categories(v-if="categories")
	.categories__container.container
		.categories__wrap
			h1.categories__title(v-if="categories.title") {{categories.title}}
			.categories__items.flc
				.categories__grid
					template(v-for="(item, index) in categories.items" :key="index")
						.categories__col.flc
							a.category-item(v-if="item.link" :href="item.link")
								.category-item__name.flc(v-if="item.name") {{item.name}}
								.category-item__note.flc(v-if="item.note") {{item.note}}
								img.category-item__image.flc(:src="item.image" alt="" loading="lazy")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			categories: null
		};
	},

	methods: {
		dataSet(data) {
			this.categories = data;
		}
	}
};
</script>